import { type I18n } from "~/features/i18n/utils";
import { __IS_DEV__ } from "~/features/app/utils";
import { buildSanityImageSrc, isSanityImageUrl } from "~/features/sanity/media/image-url";
export function generateAlternates(i18n?: I18n) {
  if (!i18n || !i18n.alternates?.length) {
    return [];
  }
  const {
    locale,
    href,
    alternates
  } = i18n;
  return [{
    hrefLang: locale || "en",
    href: __IS_DEV__ ? href!.replace(process.env.NEXT_PUBLIC_HOMEPAGE_SLUG, "").replace(process.env.NEXT_PUBLIC_URL, "") : href!.replace(process.env.NEXT_PUBLIC_HOMEPAGE_SLUG, "")
  }, ...alternates!.map(item => {
    const hrefLang = item.hrefLang || "en";
    const href = __IS_DEV__ ? item.href!.replace(process.env.NEXT_PUBLIC_HOMEPAGE_SLUG, "").replace(process.env.NEXT_PUBLIC_URL, "") : item.href!.replace(process.env.NEXT_PUBLIC_HOMEPAGE_SLUG, "");
    return {
      hrefLang,
      href
    };
  })];
}
export function buildAbsoluteSeoUrl(href?: string | null) {
  if (!href) {
    return undefined;
  }
  const baseUrl = process.env.NEXT_PUBLIC_URL?.trim();
  if (!baseUrl) {
    return href;
  }
  try {
    return new URL(href, baseUrl).toString();
  } catch {
    return href;
  }
}
export function buildOpenGraphImage(src: string, dimensions?: {
  height?: number | null;
  width?: number | null;
} | null) {
  if (isSanityImageUrl(src)) {
    return {
      width: 1200,
      height: 630,
      url: buildSanityImageSrc(src, {
        q: 50,
        w: 1200,
        h: 630
      })
    };
  }
  return {
    ...(dimensions?.width && dimensions.height ? {
      width: dimensions.width,
      height: dimensions.height
    } : {}),
    url: src
  };
}